<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="flex flex-col gap-4 w-full justify-center">
                    <img @click='clickShare("facebook")' class="w-16 mx-auto" src="@/assets/icon/ic-facebook.svg" alt=""/>
                    <img @click='clickShare("twitter")' class="w-16 mx-auto" src="@/assets/icon/ic-twitter.svg" alt=""/>
                    <img @click='clickShare("line")' class="w-16 mx-auto" src="@/assets/icon/ic-line.svg" alt=""/>
                </div>
                <div class="flex mt-6">
                    <img class="w-10 h-10 m-auto" @click="clickCancel()" src="@/assets/icon/ic-close-tranparent.svg" alt=""/>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "ShareModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            tag: '',
            title: '',
            message: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.tag = config.tag;
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.button.cancel;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        clickShare: function(shareType) {
            this.hide();
            this.controller.sendCallbackShare(shareType)
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
        .modal-content {
            overflow: unset;
            width: 100%;
            max-width: 414px;
            padding: 0 16px;
        }
    }
</style>
